
<!--
  功能：客户中心-电商转链
-->
<template>
  <div class="ecConvertLink">
    <div class="page-title top0">电商转链</div>
    <div class="form">
      <el-form :inline="true" size="medium">
        <el-form-item label="公司名称">
          <el-select v-model="filterParam.enterpriseId" placeholder="请选择公司名称" filterable clearable @change="getConvertLinkList">
            <el-option v-for="item in companyList" :key="item.id" :label="item.enterpriseName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称/ID">
          <el-input v-model="filterParam.searchName" @blur="getConvertLinkList()" placeholder="请输入商品名称或ID"></el-input>
        </el-form-item>
        <el-form-item label="PID">
          <el-input v-model="filterParam.pid" @blur="getConvertLinkList()" placeholder="请输入PID"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="getConvertLinkList()">搜索</el-button>
        </el-form-item>
        <el-form-item label="" style="float:right;">
          <div class="btn clearfix">
            <el-button type="primary" size="medium" icon="" @click="createConvertLink">新建转链</el-button>
            <el-button type="primary" size="medium" icon="" @click="downloadList" :disabled="listSelection.length<=0">导出已选数据</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table ref="table" class="roleTable" :max-height="tabheight" :data="ecConvertLinkList" border @selection-change="handleSelectionChange" v-loading="tableLoading">
        <el-table-column type="selection" width="50" v-if="pageTotal>0"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"  min-width="160"></el-table-column>
        <el-table-column prop="enterpriseId" label="公司ID"  min-width="100"></el-table-column>
        <el-table-column prop="enterpriseName" label="公司名称"  min-width="100"></el-table-column>
        <el-table-column prop="type" label="联盟类型" min-width="100">
          <template slot-scope="scope">
            {{ typeName[scope.row.type] }}
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" label="商品名称" min-width="200"></el-table-column>
        <el-table-column prop="goodsId" label="商品ID" min-width="180"></el-table-column>
        <el-table-column prop="authId" label="授权ID" min-width="120"></el-table-column>
        <el-table-column prop="pid" label="PID" min-width="200"></el-table-column>
        <el-table-column
          prop="promoteUrl"
          label="落地页链接" width="240">
          <template slot-scope="scope">
            <div v-if="scope.row.promoteUrl == ''">/</div>
            <el-popover  v-else
              placement="top"
              width="320"
              trigger="hover"
              :content="scope.row.promoteUrl">
              <p class="copy" slot="reference" :data-clipboard-text='scope.row.promoteUrl'>{{scope.row.promoteUrl}}<i class="iconfont icon-copy"></i></p>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="agentClickMonitorUrl"
          label="点击监测链接" width="240">
          <template slot-scope="scope">
            <div v-if="scope.row.trackUrl == ''">/</div>
            <el-popover  v-else
              placement="top"
              width="320"
              trigger="hover"
              :content="scope.row.trackUrl">
              <p class="copy" slot="reference" :data-clipboard-text='scope.row.trackUrl'>{{scope.row.trackUrl}}<i class="iconfont icon-copy"></i></p>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="openUrl"
          label="DP链接" width="240">
          <template slot-scope="scope">
            <div v-if="scope.row.openUrl == ''">/</div>
            <el-popover  v-else
              placement="top"
              width="320"
              trigger="hover"
              :content="scope.row.openUrl">
              <p class="copy" slot="reference" :data-clipboard-text='scope.row.openUrl'>{{scope.row.openUrl}}<i class="iconfont icon-copy"></i></p>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging-box" v-if="pageTotal>0">
        <!-- <span class="page-total">显示全部项目{{pageTotal}}个项目</span> -->
        <el-pagination background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="filterParam.pageNum"
          :page-sizes="[ 10, 20, 40, 80, 100]"
          :page-size="filterParam.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pageTotal">
        </el-pagination>
      </div>
    </div>
    <!-- 新建转链 -->
    <div class="createConvertLink" v-if="createLinkVisible">
      <el-dialog title="新建转链" :visible.sync="createLinkVisible" :close-on-click-modal="false" width="600px">
        <el-form ref="createLinkForm" :model="createLinkForm" :rules="createLinkRules" label-width="120px" class="form">
          <el-form-item label="联盟类型" prop="type">
            <el-select v-model="createLinkForm.type" @change="changeRulesInfo">
              <el-option v-for="item in platformList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="authIdName" prop="authId" v-if="createLinkForm.type!==3&&createLinkForm.type !== 4">
            <el-input v-model="createLinkForm.authId" :placeholder="'请输入'+authIdName"></el-input>
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input v-model="createLinkForm.goodsName" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item :label="goodsIdName" prop="goodsId">
            <el-input v-model="createLinkForm.goodsId" :placeholder="'请输入'+goodsIdName" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="PID" prop="pid" v-if="createLinkForm.type !== 4">
            <el-input v-model="createLinkForm.pid" placeholder="请输入PID"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <el-button size="medium" @click="createLinkVisible=false">取 消</el-button>
              <el-button size="medium" type="primary" :loading="createLinkLoading" @click="createLinkSubmit('createLinkForm')">保 存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
// 公用
import { getTimeAll } from '@/components/public'
// 表单验证
import { notNullable, notNullableChange } from '@/components/form/formValidation'
import Clipboard from 'clipboard'

export default {
  // 组件名称
  name: 'ecConvertLink',
  // 组件参数 接收来自父组件的数据
  props: {
  },
  // 组件状态值
  data() {
    // pid验证
    const pidFormat = async (rule, value, callback) => {
      let reg = this.pidReg
      if (!reg.test(value.replace(/ /g, ''))) {
        return callback(new Error('PID格式有误，请重新输入'))
      } else {
        callback()
      }
    }
    return {
      tableLoading: false,
      // 筛选参数
      filterParam: {
        enterpriseId: '',
        searchName: '',
        pid: '',
        pageNum: 1, // 初始当前显示页
        pageSize: 10, // 初始每页的数据条数
        timeEnd: '',
        timeStar: ''
      },
      pageTotal: 0, // 数据总条数
      tabheight: null,
      // 公司列表
      companyList: [],
      // 转链列表
      ecConvertLinkList: [],
      listSelection: [],
      // 新建转链
      createLinkVisible: false,
      createLinkLoading: false,
      // 1-淘宝联盟 2-京东联盟 3-多多进宝
      platformList: [{
        id: 1,
        name: '淘宝联盟'
      }, {
        id: 2,
        name: '京东联盟'
      }, {
        id: 3,
        name: '多多进宝'
      }, {
        id: 4,
        name: '点点诺-淘宝'
      }],
      typeName: ['', '淘宝联盟', '京东联盟', '多多进宝', '点点诺-淘宝'],
      createLinkForm: {
        type: 1,
        goodsName: '',
        goodsId: '',
        authId: '',
        pid: ''
      },
      pidReg: '',
      authIdName: '',
      goodsIdName: '',
      createLinkRules: {
        type: [
          notNullableChange('联盟类型')
        ],
        goodsName: [
          notNullable('商品名称')
        ],
        pid: [
          notNullable('PID'),
          { required: true, validator: pidFormat, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    createLinkVisible(to) {
      if (!to) {
        this.resetForm('createLinkForm')
      }
    }
  },
  mounted() {
    // 复制
    this.copyLink()
    this.getAllCompanyList()
    this.getConvertLinkList()
  },
  methods: {
    changeRulesInfo() {
      if (this.createLinkForm.type === 1) {
        this.pidReg = /^mm_[0-9]+_[0-9]+_[0-9]+$/
        this.authIdName = '平台授权ID'
        this.goodsIdName = '商品ID'
      } else if (this.createLinkForm.type === 2) {
        this.pidReg = /^[0-9]+_[0-9]+_[0-9]+$/
        this.authIdName = '联盟ID'
        this.goodsIdName = 'skuID'
      } else if (this.createLinkForm.type === 3) {
        this.pidReg = /^[0-9]+_[0-9]+$/
        this.goodsIdName = 'goodsSign'
      }
      if (this.createLinkForm.type !== 3) {
        this.createLinkRules.authId = [
          notNullable('请输入' + this.authIdName)
        ]
      }
      this.createLinkRules.goodsId = [
        notNullable('请输入' + this.goodsIdName)
      ]
      this.$nextTick(() => {
        this.$refs['createLinkForm'].clearValidate(['goodsName', 'authId', 'goodsId', 'pid'])
      })
    },
    // 企业列表
    getAllCompanyList() {
      this.$service.post('/api/enterprise/getAllOpenCompanyList').then(res => {
        this.companyList = res.result
      }).catch(Err => {
      })
    },
    // 点击复制
    copyLink () {
      this.clipboard = new Clipboard('.copy')
      this.clipboard.on('success', e => {
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      })
      this.clipboard.on('error', e => {
        this.$message({message: '复制失败', type: 'error'})
      })
    },
    // 列表自动高度
    updatetabheight() {
      if (!this.tabheight) {
        let height = document.documentElement.clientHeight
        let offsetTop = this.$refs.table.$el.getBoundingClientRect().top
        console.log('offsetTop', offsetTop)
        this.$nextTick(() => {
          this.tabheight = parseInt(height - offsetTop - 20) > 300 ? parseInt(height - offsetTop - 20) : 300
        })
      }
    },
    // 获取列表数据
    getConvertLinkList() {
      console.log('getConvertLinkList', this.filterParam)
      this.tableLoading = true
      this.$service.post('/api/transfer/link/manage/list', this.filterParam).then(res => {
        res.result.pageData.forEach(item => {
          item.createTime = getTimeAll(new Date(item.createTime))
        })
        this.ecConvertLinkList = res.result.pageData
        this.pageTotal = res.result.total
        if (this.ecConvertLinkList.length > 4) {
          this.updatetabheight()
        } else {
          this.tabheight = null
        }
        this.tableLoading = false
      }).catch(Err => {
        this.tableLoading = false
      })
    },
    // 新建转链
    createConvertLink() {
      if (this.filterParam.enterpriseId && this.filterParam.enterpriseId !== '') {
        this.createLinkVisible = true
        this.changeRulesInfo()
      } else {
        this.$message({
          message: '请选择公司名称',
          type: 'warning'
        })
      }
    },
    // 提交
    createLinkSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.createLinkLoading = true
          let param = {
            enterpriseId: this.filterParam.enterpriseId,
            goodsId: this.createLinkForm.goodsId,
            goodsName: this.createLinkForm.goodsName,
            pid: this.createLinkForm.pid,
            type: this.createLinkForm.type
          }
          if (this.createLinkForm.type !== 3 && this.createLinkForm.type !== 4) {
            param.authId = this.createLinkForm.authId
          }
          if (this.createLinkForm.type === 4) {
            param.pid = 'mm_9_9_9'
            param.authId = '999999'
          }
          this.$service.post('/api/transfer/link/manage/add', param).then(res => {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.getConvertLinkList()
            this.createLinkVisible = false
            this.createLinkLoading = false
          }).catch(Err => {
            this.createLinkVisible = false
            this.createLinkLoading = false
          })
        } else {
          this.createLinkLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    // 导出
    downloadList() {
      let ids = this.listSelection.map(item => { return item.id })
      // 创建a标签下载
      let link = document.createElement('a')
      link.style.display = 'none'
      link.target = '_blank'
      link.href = this.$instance.defaults.baseURL + '/api/transfer/link/manage/export?idList=' + ids
      console.log(link.href)
      link.setAttribute('download', '')
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    // 保存选中结果
    handleSelectionChange (val) {
      this.listSelection = val
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      this.filterParam.pageSize = size
      this.getConvertLinkList()
    },
    // 切换分页
    handleCurrentChange (currentPage) {
      this.filterParam.pageNum = currentPage
      this.getConvertLinkList()
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  // 销毁实例  vue钩子 退出当前页面
  destroyed () {
    this.clipboard.destroy()
  }
}
</script>

<style lang="less" scoped>
.ecConvertLink{
  .createConvertLink{
    .form{
      .el-form-item{
        margin-bottom: 22px;
      }
      .el-select,
      .el-input{
        width: 90%;
      }
    }
    .btn{
      .el-button{
        width: 80px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/operationManage/ecConvertLink.vue